import { Navigate, Outlet } from 'react-router';

import { DASHBOARD } from '@/constants/routes';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import Loader from '@/UI/Loader';

/**
 * Route guard for admin-only pages. Redirects non-admin users to the dashboard.
 */
const AdminRoute = () => {
  const { isAdmin, loading } = useCurrentUser();

  if (loading) {
    return <Loader centered />;
  }

  if (!isAdmin) {
    return <Navigate to={DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
